export default __webpack_public_path__ + "static/media/KZ.T.14.Е1213 black.5ad60ce6.svg";